import React from "react";

import UserFeedbackActivityHistoryPageView from "./UserFeedbackActivityHistoryPageView";
import { UserFeedbackDetailsPageView } from "./UserFeedbackDetailsPageView";

export function UserFeedbackView() {
  return <UserFeedbackDetailsPageView />;
}

export function ActivityHistoryView() {
  return <UserFeedbackActivityHistoryPageView />;
}
